import React from 'react';
import GlyphSvg from '../components/Glyphs';

export default function IntroBlock() {
  return (
    <div className="py-5 px-2 dark-section b-c5" >
      <h2 className="wrap-icon pb-4 text-center">
        <GlyphSvg glyph={'g06'} size={"24"} color={"white"} /> <GlyphSvg glyph={'g01'} size={"24"} color={"white"} /> <GlyphSvg glyph={'g02'} size={"24"} color={"white"} /> <br />
      </h2>
      <h3 className="large-title text-center text-white fs-1 pb-2 f-uc" >
        Reduce photo costs,<br /> increase conversions,<br className="d-block d-md-none" /> test avatars, ethnicity,<br /> expression and more.
      </h3>
      <h2 className="wrap-icon pb-4 text-center">
        <GlyphSvg glyph={'g09'} size={"24"} color={"white"} />
      </h2>
    </div>
  );
}   